export const HASH_OID_TO_NAME: Record<string, string> = {
  "1.2.840.113549.2.5": "MD5",
  "1.3.14.3.2.26": "SHA-1",
  "2.16.840.1.101.3.4.2.4": "SHA-224",
  "2.16.840.1.101.3.4.2.1": "SHA-256",
  "2.16.840.1.101.3.4.2.2": "SHA-384",
  "2.16.840.1.101.3.4.2.3": "SHA-512",
};

/** Web Crypto algorithm identifiers for the digests we can recompute. */
export const HASH_OID_TO_WEBCRYPTO: Record<string, string> = {
  "1.3.14.3.2.26": "SHA-1",
  "2.16.840.1.101.3.4.2.1": "SHA-256",
  "2.16.840.1.101.3.4.2.2": "SHA-384",
  "2.16.840.1.101.3.4.2.3": "SHA-512",
};

export const WEAK_HASH_OIDS = new Set([
  "1.2.840.113549.2.5",
  "1.3.14.3.2.26",
]);

export const KNOWN_POLICY_OIDS: Record<string, string> = {
  "1.3.6.1.4.1.66538.1.1": "Sunlit Bytes TSA Policy (v1)",
  "2.25.312690151706139119217803799449385446861":
    "Sunlit Bytes TSA Policy (v1, interim pre-PEN arc)",
  "1.3.6.1.4.1.13762.3": "FreeTSA policy",
  "2.16.840.1.114412.7.1": "DigiCert timestamping policy",
};

export const SIG_OID_TO_NAME: Record<string, string> = {
  "1.2.840.113549.1.1.1": "RSA",
  "1.2.840.113549.1.1.11": "RSA with SHA-256",
  "1.2.840.113549.1.1.13": "RSA with SHA-512",
  "1.2.840.10045.2.1": "ECDSA",
  "1.2.840.10045.4.3.2": "ECDSA with SHA-256",
  "1.2.840.10045.4.3.3": "ECDSA with SHA-384",
};

export const OID_TIMESTAMPING_EKU = "1.3.6.1.5.5.7.3.8";
export const OID_SIGNED_DATA = "1.2.840.113549.1.7.2";
export const OID_TST_INFO = "1.2.840.113549.1.9.16.1.4";

export function hashName(oid: string): string {
  return HASH_OID_TO_NAME[oid] ?? oid;
}

export function policyName(oid: string): string | undefined {
  return KNOWN_POLICY_OIDS[oid];
}
